import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function MotivasyonTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['motivasyon-testi']} />;
}
